export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "Car Loan Eligibility Calculator: Find Out How Much You Can Borrow",
    subHeading:
      "Have you tried Minemi's Car Loan Eligibility Calculator? This smart tool provides an instant estimate of your car loan eligibility based on your income, obligations, and credit profile. Whether you're looking to buy a new car or a used one, this calculator gives you insights tailored to different lenders' criteria.",

    notice:
      "This page will guide you through the factors affecting car loan eligibility, help you interpret your results, and offer actionable tips to secure the best loan terms.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
